import HomePage from "./homepage/index.page";

export default HomePage;
